import { FC } from "react";

export const Pengumuman: FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="121" height="121" viewBox="0 0 121 121" fill="none" {...props}>
    <g clip-path="url(#clip0_1_1154)">
      <path
        d="M71.4443 27.8161L88.1381 33.0053L93.3273 49.699L103.421 35.426L120.838 35.6494L110.444 21.6445L116.06 5.08356L99.476 10.7076L85.494 0.56543L85.7174 17.7224L71.4443 27.8161ZM92.6974 14.4641L98.2922 18.5226L104.841 16.3024L102.613 22.8741L106.748 28.446L99.8193 28.3572L95.8093 34.0289L93.7475 27.3959L87.1145 25.3341L92.7862 21.3232L92.6974 14.4641Z"
        fill="#74B3DF"
      />
      <path d="M65.1099 2.83398H72.132V22.6936H65.1099V2.83398Z" fill="#74B3DF" />
      <path d="M98.3799 49.4106H118.24V56.4318H98.3799V49.4106Z" fill="#74B3DF" />
      <path
        d="M40.558 25.9703L46.1089 31.522L10.0005 94.7126L5.8028 90.5159L0.837891 95.4808L25.6633 120.305L30.6282 115.34L26.4305 111.144L39.0685 103.922L48.0049 112.858C54.8659 119.718 65.9694 119.719 72.8304 112.858C79.6904 105.998 79.6913 94.8948 72.8304 88.0339L70.6642 85.8677L89.6212 75.0343L95.1729 80.5861L100.138 75.6212L45.5229 21.0054L40.558 25.9703ZM15.1467 99.8588L44.0343 49.3062L71.837 77.1098L21.2844 105.997L15.1467 99.8588ZM67.8655 92.9979C71.9817 97.115 71.9817 103.776 67.8655 107.893C63.7493 112.01 57.087 112.01 52.9698 107.893L45.3646 100.324L64.3453 89.4777L67.8655 92.9979ZM78.156 73.499L47.6442 42.9872L51.256 36.6682L84.475 69.8881L78.156 73.499Z"
        fill="#74B3DF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1154">
        <rect width="120" height="120" fill="white" transform="translate(0.837891 0.331055)" />
      </clipPath>
    </defs>
  </svg>
);
